<template>
    <Card :header="$t('filters')">

        <form @keyup.enter="parentComponent.filterData()">

            <b-form-group :label="$t('space')" label-cols-sm="3">
                <MultiselectSpaces
                    :initial-value="parentComponent.filtersParams.spaceId"
                    :disabled="parentComponent.disabled"
                    :multiple="false"
                    :show-checkboxes="false"
                    :close-on-select="true"
                    @inputTrackBy="parentComponent.filters.spaceId = $event"
                />
            </b-form-group>

            <b-form-group label-cols-sm="3" :label="$t('shop')">
                <b-form-input v-model="parentComponent.filters.name" />
            </b-form-group>

            <b-form-group label-cols-sm="3" :label="$t('category')">
                <Multiselect
                    :placeholder="$t('selectField.placeholder')"
                    :fetch-options-function="fetchCategories"
                    :close-on-select="false"
                    :searchable="true"
                    :multiple="true"
                    track-by="id"
                    label="name"
                    select-label=""
                    :disabled="parentComponent.disabled"
                    :initial-value="parentComponent.filtersParams.categories"
                    @inputTrackBy="parentComponent.filters.categories = $event"
                />
            </b-form-group>

            <b-form-group :label="$t('status')" label-cols-sm="3">
                <b-form-checkbox-group v-model="parentComponent.filters.statuses" :options="optionsStatuses" class="h-100 d-flex align-items-center" />
            </b-form-group>

            <div class="d-flex gap-3">
                <ButtonIcon
                    icon="filter"
                    :loading="parentComponent.loading"
                    :disabled="!parentComponent.filters.spaceId"
                    hide-label-while-loading
                    class="wide"
                    @click="parentComponent.filterData()"
                >
                    {{ $t('filter') }}
                </ButtonIcon>
            </div>
        </form>

    </Card>
</template>



<script>
    import MultiselectSpaces from '@/components/common/MultiselectSpaces.vue';
    import Multiselect from '@/components/common/Multiselect.vue';

    export default {
        name: 'Filters',
        components: {
            MultiselectSpaces,
            Multiselect,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                requestCategories: this.$req('category/buyboxCategories'),
            };
        },
        computed: {
            optionsStatuses() {
                return this.$store.getters['space/campaignStatusOptions'];
            },
        },
        methods: {
            fetchCategories() {
                return this.requestCategories.get();
            },
        },
    };
</script>
